import React from 'react';

/* eslint-disable max-len,no-tabs,camelcase */
const Hair_14 = ({ hairColours }) => {
  const primary = hairColours.base;
  const secondary = hairColours.shadow;
  return (
    <>
      <g>
        <path
          fill={primary}
          d="M419.4,194.4c25.3-3.2,117.5,32,110,66.7c-3.9,18.1-17.1,41.7-25.1,52.3c0.6-23.7-13.4-50.4-28.5-64.9
		c4.5,37.7-33.3,40.5-37.9,68.6c0,0.4,0,0.8,0,1.1c0-0.4,0-0.8,0-1.1c-0.4-7-1.8-13.9-1.9-21.3c-8.7,16.5-15.2,28.9-14.3,49.6
		c-2.8-3.4-8.2-5.2-11.3-9.5c-2.8,12.6-2.9,26.7-1.9,40c-7.2-2.7-13.5-9.1-17.7-17c-2.3,14.1,19.7,48.5,28.7,57.7
		c-16.3,2-47.5-19.5-57.9-45.5c-15,18.8,2.8,40.4,1.8,61.1c-0.7,16.6-15,56.8-28.4,63.7c-4.2,2.2-5.2,3.6-10.7,3.4
		c1.4-3.4,1.4-9.7,2.7-13.5c-8.7,3.9-17.9,0.6-24.5-6.3c34.7-22.7-39.8-92.2-48.1-115.3c-14.6-40.8-4.4-92.3,17.2-125.3
		c28.5-43.6,67.6-74.1,115.9-65.2c12.3,2.3,24.8,7.2,31.3,20.8L419.4,194.4z"
        />
        <g>
          <g>
            <path
              fill={secondary}
              d="M421.2,205.9c4.2,49-29.8,81.2-25.7,129.8c0.7,8.3,3.1,16.7,5.2,24.6c-37.4-30.2,9.7-90.9,17-122
				c1.3-5.6,2-11.8,2-17.9L421.2,205.9z"
            />
            <path
              fill={secondary}
              d="M403.4,209c-15.7,43.2-48.1,69.3-48.8,119.7c-0.1,6.8,0,13.3,1.1,19.6c0,0.1,0.1,1.7,0,0.7
				c2.5-48.1,22.9-76.4,40.4-117.9C398.3,226,402.3,214.6,403.4,209L403.4,209z"
            />
            <path
              fill={secondary}
              d="M381.4,193.2c-19.7,34.2-52,57.9-67.8,95.6c-17,40.7-16.9,96.5,13.8,127.7c-21.6-42-20-90.5,3.7-130.8
				C347.9,257.2,373.8,227.9,381.4,193.2L381.4,193.2z"
            />
            <path
              fill={secondary}
              d="M310.7,433.3c-6.2-24.8-22-41.5-30.3-64.5c-9.2-25.6-2.7-57.4,3-83.1c6.2-27.6,20.2-60.2,44.4-70.4
				c-33.6,34-53,107.9-34.4,156.5C301.6,393.2,312.9,407.3,310.7,433.3L310.7,433.3z"
            />
            <path
              fill={secondary}
              d="M343.1,179.9c-36.1,0.7-69,61.8-79.8,96.9c-3.1,10.2-6.7,19.7-7.2,30.8c6.3-42.3,53.8-103.1,83.4-124.1
				L343.1,179.9z"
            />
            <path
              fill={secondary}
              d="M419.4,194.4c29-4,82.7-0.3,99,36c3.8,8.5,5,18.1,3.9,27.9c-0.1,0-1,1.1-1,1.3c0.2,0.4-3.9-2.5-4-2.5
				c17.1-42.6-57.2-56.1-76.7-59.4c-2.4-0.4-4.9-0.9-7.3-1.3L419.4,194.4z"
            />
            <path
              fill={secondary}
              d="M423.5,253.7c-5.5,14.8-12.7,29.4-16.8,44.8c-0.2-3.1-1-6.9-1.2-10.4c-1.3,3.6-4.8,8.5-6.1,12.2
				c-0.4-3.8-1.1-8.4-1.2-12.1c-0.9-1.1-2.3,3.8-3.2,2.8c-0.3-2.8,0.4-5.6-1-8.1c-7,9.7-8.1,24.2-14.4,34.3c-3.2-9.3-4.9-19-5-29.1
				c-1.6,2.5-5.5,6.1-6.7,8c-1.4-1.7-0.5-5-1.9-6.8c-2.4,1.2-3.3,3.7-6.3,4.5c-0.3-1.6-1.3-6.8-2-8c-13.6,10.6-15.9,31.5-21,48.3
				c-2.1-8.1-3-16.6-3.1-25c-1.2,5.4-5.2,10.8-7.1,15.6c-3.5-6.9-4.5-14.7-3.4-22.8c0-0.4,0-0.4,0,0c-0.4,0.7-2.1,4.2-2.5,4.9
				c0.1-6.1-2.8-13.8-3.4-19.8c-2.7,1.2-3.7,2-6.1,4.5c0-2.9-0.6-6.7-0.7-9.8c-6.9,5.3-12.7,13.8-16.2,22.6
				c-0.8-7.5-1.2-16.7-2-23.4c-1.6,2.2-4.3,4.6-5.7,6.4c-1-2.9-1.2-6.9-1.6-9.7c-1.9,0.4-3,2.5-5.1,1.1c1.5-5,0.5-11.9,1.8-16.9
				c-2.2,0.7-5.2,0.6-7.1,1.1c6.8-19.7,17.3-41,33.2-52.3c-2.3,4-3.9,9.5-6.3,13.7c0,0-0.6,0.8-0.3,0.3c2.3-1.8,5.2-3.3,7.2-4.8
				c0.6,2.5-0.5,6.3,0,8.6c2.5-0.6,4.4-2.5,6.6-3.3c0.1,0.5,0.2,4.6-0.3,4.5c11.6,0.1,19-8.6,27.4-16.6c-4.7,7-9.4,14.8-11,23.6
				c7.4-4,16.3-7.3,22.5-13.7c-1.2,3-1.7,6.6-3.1,9.8c2.1-0.5,4-2.4,6.1-2.3c-0.6,3.9,0.6,9.5,0,13.8c7.4-2.7,13-11.3,19.2-16.1
				c-0.9,8-2.4,16.3-3.2,24.3c0,0,1.9,0.1,1.9,0.2c5.4-9.3,11.2-18.6,16.3-28c-0.3,3.9,0.5,8.2,0.2,12.1c1.6-1,3.4-3,5.1-3.3
				c1.9,11.2-2.1,22.5-1.8,34.2c7.4-9.6,10.8-25.4,16.8-36.6c-0.3,3.6,0.7,8.7,0.5,12.7c3.4-3.6,9.3-7.8,12.5-12.7
				c-0.4,4.9,0.3,9.9-0.9,15c0.3-0.1,3.6-1.2,3.7-1c-0.9,3.2-2.3,6-3.3,9.3V253.7z"
            />
            <path
              fill={secondary}
              d="M433.7,209.5c13.6,10.1,26.8,24.5,25.5,45.6c-1.1,16.9-15.1,25.6-15.9,41.7c-5.6-24.7,16.3-53.3-1.8-75
				L433.7,209.5z"
            />
            <path
              fill={secondary}
              d="M441.4,205.4c33.2,16.3,59,29.5,65.7,76.4c0.2,0.4,0.2,0.4,0,0c-6.5-17.6-12.6-36.7-27.1-47.3L441.4,205.4z"
            />
          </g>
        </g>
      </g>
    </>
  );
};

export default Hair_14;
